import type { Locale } from 'date-fns';
import { pl } from 'date-fns/locale/pl';
import { enUS } from 'date-fns/locale/en-US';
import { uk } from 'date-fns/locale/uk';
import { be } from 'date-fns/locale/be';

/**
 * The date-fns locale for an i18n language code, so any `format()` that emits weekday / month /
 * am-pm names renders in the viewer's language. Pass the result as `{ locale }` to `format()`.
 *
 * WHY this exists: `format(date, 'EEE d MMM')` defaults to ENGLISH unless a locale is passed, so a
 * date can look fully i18n-compliant in code yet render "Thursday" in a Polish UI. Route every such
 * format through this helper. A guard test (i18nDate.guard.test.ts) fails the build on any
 * locale-sensitive `format()` call that omits `locale`.
 */
const LOCALES: Record<string, Locale> = { pl, en: enUS, ua: uk, by: be };

export function dateFnsLocale(lang: string): Locale {
  return LOCALES[lang] ?? enUS;
}
